import React from 'react';
import { Box, CircularProgress } from '@mui/joy';
import { Navigate, useParams } from 'react-router-dom';
import { useProfile } from '../hooks/useProfile';
import FitterJobsPage from './FitterJobsPage';
import FitterJobCardPage from './FitterJobCardPage';
import { decideJobRecordsGate } from './decideJobRecordsGate';

const SiteCrewRecordsGate: React.FC = () => {
  const { isSiteCrew, loading, profile } = useProfile();
  const { projectId } = useParams<{ projectId?: string }>();
  const view = decideJobRecordsGate({
    loading,
    hasProfile: Boolean(profile),
    isSiteCrew,
    projectId,
  });

  if (view === 'wait') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress size="sm" />
      </Box>
    );
  }
  if (view === 'crew-list') return <FitterJobsPage />;
  if (view === 'job-card') return <FitterJobCardPage />;
  return <Navigate to="/workspaces" replace />;
};

/** Old links were /job-records/:projectId/:invoiceId; reviews are now one per workspace. */
export const LegacyJobRecordRedirect: React.FC = () => {
  const { projectId = '' } = useParams<{ projectId: string }>();
  return <Navigate to={`/projects/${encodeURIComponent(projectId)}/workspace/aftercare`} replace />;
};

export default SiteCrewRecordsGate;
